import { FC } from 'react';
import { Box, Divider, useDisclosure } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Card, { CardProps } from 'components/_core/Card';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import { AssuredBy, Offer } from '../../types';
import CoverageSummaryModal from '../CoverageSummaryModal';
import locales from './locales';

interface AsideOfferCardProps extends CardProps {
  offer: Offer;
  assuredBy: AssuredBy;
}

const AsideOfferCard: FC<AsideOfferCardProps> = ({
  assuredBy,
  offer,
  ...props
}) => {
  const { onOpen, ...modalProps } = useDisclosure();

  return (
    <>
      <Card padding="space-24" paddingBottom="space-12" {...props}>
        <SquircleIcon marginBottom="space-16" name={offer.icon} />

        <Text fontWeight="weight-500" size="lg" variant="primary">
          {offer.title}
        </Text>

        <Text paddingBottom="space-16">{offer.description}</Text>

        <Box paddingBottom="space-12">
          <Divider />
        </Box>

        <Button
          alignSelf="flex-start"
          icon="link"
          onClick={onOpen}
          size="sm"
          textAlign="left"
          variant="inline-secondary"
        >
          {locales.formatString(locales.assuredBy, assuredBy)}
        </Button>
      </Card>

      <CoverageSummaryModal {...modalProps} />
    </>
  );
};

export default AsideOfferCard;
